//Exports list of pupilare destinatiosn
export const PupularDestinationList = (window.FRONPAGE_APP_CONFIG && window.FRONPAGE_APP_CONFIG.POPULAR_DESTINATIONS) ? JSON.parse(window.FRONPAGE_APP_CONFIG.POPULAR_DESTINATIONS) : [];

export const getPuplareDestinations = () => {
    return new Promise((resolve) => resolve(PupularDestinationList));
};

export default PupularDestinationList;